<template>
    <div class="base-input__error-wrapper" data-testid="form-error">
        <span class="base-input__error-wrapper--text" data-testid="form-error-message">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ errorMessage?: string }>(), { errorMessage: '' })
</script>

<style lang="scss">
.base-input__error-wrapper {
    @apply relative w-full text-xs leading-normal;
    &--text {
        @apply inline-flex flex-wrap text-destructive-actions text-xs
        left-0 top-0 w-full overflow-hidden overflow-ellipsis whitespace-normal;
    }
}
</style>
